import { FC } from 'react';

interface TagBadgeProps {
  label: string;
}

export const TagBadge: FC<TagBadgeProps> = ({ label }) => {
  return <div className="text-xs font-medium px-2 py-1 rounded-lg bg-gray-200">{label}</div>;
};
